const accessHelpDesk = {
    TICKET_LIST: { name: 'Ticket', path: '/ticket-list' },
    TICKET_DASHBOARD: { name: 'Ticket Dashboard', path: '/my-ticket' },
    TICKET_DETAILS: { name: 'Ticket Details', path: '/ticket-details' },
    ADD_TICKET: { name: 'Add Ticket', path: '/create-ticket' },
    UPDATE_TICKET: { name: 'Update Ticket', path: '/edit-ticket' },
    DELETE_TICKET: { name: 'Delete Ticket', path: '/delete-ticket' },
    UPDATE_TICKET_STATUS: { name: 'Update Ticket Status', path: '/update-ticket-status' },
    ASSIGN_TICKET: { name: 'Assign Ticket', path: '/assign-ticket' },

    FIND_SERVICE_LIST: { name: 'Find Service', path: '/find-service-list' },
    ADD_FIND_SERVICE: { name: 'Add Find Service', path: '/create-find-service' },
    UPDATE_FIND_SERVICE: { name: 'Update Find Service', path: '/edit-find-service' },
    DELETE_FIND_SERVICE: { name: 'Delete Find Service', path: '/delete-find-service' },
    FIND_SERVICE_DETAILS: { name: 'Find Service Details', path: '/find-service-details' },

    SOS: { name: 'SOS', path: '/sos' },
    INCIDENT_REPORTS: { name: 'Incident Reports', path: '/incident-reports' },
    TECHNICAL_TICKETS: { name: 'Technical Tickets', path: '/technical-tickets' },

    ADMIN_TICKET: { name: 'Admin Ticket', path: '/admin-ticket' },
    TECHNICAL_TICKET_HISTORY: { name: 'Technical Ticket History', path: '/technical-ticket-history' },
    TECHNICAL_TICKET_DETAILS: { name: 'Technical Ticket Details', path: '/technical-ticket-details' },
    UPDATE_TECHNICAL_TICKET: { name: 'Update Technical Ticket', path: '/edit-technical-ticket' },
    DELETE_TECHNICAL_TICKET: { name: 'Delete Technical Ticket', path: '/delete-technical-ticket' },
}

export default accessHelpDesk;